import { render } from "./ClaimsView.vue?vue&type=template&id=16a87c29&ts=true"
import script from "./ClaimsView.vue?vue&type=script&lang=ts"
export * from "./ClaimsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__